var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whiteBg main"},[_c('div',{staticClass:"flex clockBox"},[_c('van-icon',{attrs:{"name":"checked","color":"#07c160"}})],1),_vm._m(0),_c('van-button',{staticClass:"pay_btn",attrs:{"type":"primary"},on:{"click":function($event){return _vm.handleCancel()}}},[_vm._v("返回")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h2',[_vm._v("支付成功")])])
}]

export { render, staticRenderFns }